import { render, staticRenderFns } from "./turmaListagem.vue?vue&type=template&id=012ab7aa&scoped=true&"
import script from "./turmaListagem.vue?vue&type=script&lang=js&"
export * from "./turmaListagem.vue?vue&type=script&lang=js&"
import style0 from "./turmaListagem.vue?vue&type=style&index=0&id=012ab7aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012ab7aa",
  null
  
)

export default component.exports